@if (showContent) {
<div class="w-full h-full flex flex-column align-items-center p-4 gap-4">

    <div class="text-5xl font-semibold text-primary">Bonjour et bienvenue sur Biifor !</div>

    @if (clients.length > 0) {
    <div class="text-2xl font-bold">Sélectionnez une organisation.</div>
    } @else {
    <div class="text-2xl font-semibold">Vous n'avez pas encore d'organisation.</div>
    }

    <!-- Liste des organisations en cards -->
    <div class="w-full flex-1 overflow-auto">
        <app-organizations-list [clients]="clients" [loading]="false"
            (organizationSelected)="onClickClient($event)"></app-organizations-list>
    </div>

    <!-- Bouton d'ajout toujours visible en bas -->
    <div class="flex align-items-center justify-content-center">
        <p-button [rounded]="true" [raised]="true" label="Ajouter une nouvelle organisation"
            icon="pi pi-plus" (click)="onClickCreateOrganization()"></p-button>
    </div>

</div>
} @else {
<app-loading></app-loading>
}